import React from 'react';
import { getTheme, useThemeMode } from '../theme';
import { HuntListing } from '../api';
import type { CartItem } from '../types';
import { fmtD } from './helpers';

export function CartSidebar({ cart, onRemove, onClose, onBook }: {
  cart: CartItem[];
  onRemove: (id: string) => void;
  onClose: () => void;
  onBook: (l: HuntListing) => void;
}) {
  const { mode } = useThemeMode();
  const T = getTheme(mode);

  return (
    <>
      <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 800 }} />
      <div style={{ position: 'fixed', top: 0, right: 0, bottom: 0, width: 'min(380px, 100vw)', background: T.surface, borderLeft: `1px solid ${T.border}`, zIndex: 801, display: 'flex', flexDirection: 'column' }}>
        <div style={{ padding: '20px 24px', borderBottom: `1px solid ${T.border}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <div style={{ color: T.text, fontSize: 17, fontWeight: 700 }}>Jaktkorgen</div>
            <div style={{ color: T.textSub, fontSize: 13, marginTop: 2 }}>{cart.length} {cart.length === 1 ? 'jakt' : 'jakter'} valda</div>
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: T.textSub, fontSize: 20, cursor: 'pointer' }}>Stäng</button>
        </div>
        <div style={{ flex: 1, overflow: 'auto', padding: '16px 24px' }}>
          {cart.length === 0
            ? <div style={{ textAlign: 'center', padding: '60px 20px', color: T.textSub }}><div style={{ fontSize: 14 }}>Korgen är tom</div><div style={{ fontSize: 12, marginTop: 4 }}>Bläddra bland jakterna och klicka på + Korg</div></div>
            : cart.map(item => (
              <div key={item.listing.id} style={{ border: `1px solid ${T.border}`, borderRadius: 6, overflow: 'hidden', marginBottom: 14 }}>
                <div style={{ position: 'relative', height: 110 }}>
                  <img src={item.listing.imageUrl} alt={item.listing.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top, rgba(34,38,34,0.8) 0%, transparent 50%)' }} />
                  <button onClick={() => onRemove(item.listing.id)} style={{ position: 'absolute', top: 8, right: 8, background: 'rgba(0,0,0,0.7)', border: 'none', color: T.textSub, fontSize: 14, width: 28, height: 28, borderRadius: '50%', cursor: 'pointer' }}>✕</button>
                </div>
                <div style={{ padding: '12px 14px' }}>
                  <div style={{ color: T.text, fontSize: 14, fontWeight: 700, marginBottom: 4 }}>{item.listing.title}</div>
                  <div style={{ color: T.textSub, fontSize: 12, marginBottom: 10 }}>{item.listing.location} · {fmtD(item.listing.startDate)}</div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ color: T.amber, fontSize: 16, fontWeight: 700 }}>{item.listing.price > 0 ? `${item.listing.price.toLocaleString('sv-SE')} kr` : 'Kontakta'}</div>
                    <button onClick={() => onBook(item.listing)} style={{ background: T.amber, color: '#000', border: 'none', borderRadius: 4, padding: '7px 16px', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>Boka & Signera →</button>
                  </div>
                </div>
              </div>
            ))
          }
        </div>
        {cart.length > 0 && <div style={{ padding: '16px 24px', borderTop: `1px solid ${T.border}` }}><div style={{ color: T.textSub, fontSize: 12 }}>Klicka "Boka & Signera" på varje jakt för att skriva avtal digitalt.</div></div>}
      </div>
    </>
  );
}
